/**
 * @file PriorityButtons.jsx
 * @location src/components/modals/taskform/PriorityButtons.jsx
 * @role 긴급도 선택 버튼 그룹 — PRIORITY_OPTIONS 단일 매핑. TaskModalStep2·TaskDetailHeaderEdit 공용.
 */
import { PRIORITY_OPTIONS } from '../../../data/constants';

/**
 * @param {object} props
 * @param {string} props.value
 * @param {(val: string) => void} props.onChange
 * @param {boolean} [props.compact]  pri-btns-sm 변형(상세 헤더 인라인용)
 */
export function PriorityButtons({ value, onChange, compact = false }) {
  return (
    <div className={`pri-btns${compact ? ' pri-btns-sm' : ''}`}>
      {PRIORITY_OPTIONS.map(([val, label]) => (
        <button
          key={val}
          type="button"
          className={`pri-btn ${val}${value === val ? ' sel' : ''}`}
          onClick={() => onChange(val)}
        >{label}</button>
      ))}
    </div>
  );
}
